import searchAtomPair, { type SearchParams } from 'atoms/search-atom';
import { mutationAtomWithLoadable } from 'lib/atoms';
import request from 'lib/request';
import type {
  DifferentialScenarioResult,
  DifferentialScenarioFacets,
  DifferentialScenarioAggregations,
} from './types';

export interface DifferentialScenarioParams extends SearchParams {
  name?: string;
  createdBy?: string[];
  createdAt?: { start?: string; end?: string };
  updatedAt?: { start?: string; end?: string };
  effectiveDate?: { start?: string; end?: string };
}

export const DEFAULT_PARAMS: DifferentialScenarioParams = {
  page: 1,
  pageSize: 100,
};

export const createDifferentialScenarioSearchAtom = () =>
  searchAtomPair<
    DifferentialScenarioResult,
    DifferentialScenarioParams,
    DifferentialScenarioFacets,
    DifferentialScenarioAggregations
  >({ href: '/queries/differential_scenarios' }, DEFAULT_PARAMS);

interface ClonedDifferentialScenario {
  id: number;
  href: string;
}

/**
 * POSTs to the BE clone endpoint for a scenario by id and returns the cloned
 * scenario's identity. Mirrors the DRS clone-atom pattern.
 * @param {number} id - The source scenario id
 * @return {ClonedDifferentialScenario} The cloned scenario (id + href)
 */
export const [cloneScenarioAtom] = mutationAtomWithLoadable(
  async (_get, _set, id: number): Promise<ClonedDifferentialScenario> => {
    const response = await request.post<ClonedDifferentialScenario, unknown>(
      `/differential_scenarios/${id}/clone`,
      {},
      new AbortController()
    );

    if (response.type !== 'success') {
      throw new Error('Failed to clone differential scenario');
    }
    return response.data;
  }
);
